import React from "react";
import { SketchPicker } from 'react-color';
import { langCheck } from "Pub/js/utils.js";
import platform from "Pub/js/platform";
const { base } = platform;
const { NCButton, NCFormControl } = base;
import "./index.less";

export default class ColorPicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            colorPicker: { // 取色器
                show: false, // 显示or隐藏
                preview: '', // 当前预览色
            },
        };
    }

    // 取色器取消
    colorPickerCnacel = () => {
        const { colorPicker } = this.state;
        this.setState({
            colorPicker: {
                ...colorPicker,
                show: false,
            },
        });
    }

    // 取色器确定
    colorPickerConfirm = () => {
        const { onChange } = this.props;
        const { colorPicker } = this.state;
        const { preview } = colorPicker;
        this.setState({
            colorPicker: {
                ...colorPicker,
                show: false,
            },
        });
        onChange(preview);
    }
    
    render() {
        const { className = '', color, disabled } = this.props;
        const { colorPicker } = this.state;
        const { show, preview } = colorPicker;
        return <div className={`color-picker ${className}`}>
            <NCFormControl disabled={disabled}></NCFormControl>
            <div className="color-content" onClick={() => {
                if (!disabled) {
                    this.setState({
                        colorPicker: {
                            ...colorPicker,
                            show: true,
                            preview: color,
                        },
                    });
                }
            }}>
                <div className="color-selected" style={{ background: color }}></div>
                <div>{color}</div>
            </div>
            {
                show ? <div className="picker">
                    <SketchPicker
                        color={preview}
                        onChange={color => {
                            this.setState({
                                colorPicker: {
                                    ...colorPicker,
                                    preview: color.hex,
                                },
                            });
                        }}
                    />
                    <div className="button-content">
                        <NCButton onClick={this.colorPickerCnacel} colors="secondary">{langCheck("0000PUB-000000") /*取消*/}</NCButton>
                        <NCButton onClick={this.colorPickerConfirm} colors="primary">{langCheck('0000PUB-000001') /*确定*/}</NCButton>
                    </div>
                </div> : null
            }
        </div>;
    }
}